import { UPDATE_STORE_ID, VALIDATE_TOKEN } from '../action-types'

const initialState = {}
export default (state = initialState, { type, payload }) => {
  switch (type) {
    case VALIDATE_TOKEN:
      return { ...state, ...payload }
    case UPDATE_STORE_ID:
      return { ...state, storeId: payload }
    default:
      return state
  }
}
